module.exports = __webpack_public_path__ + "static/img/logo.eb36e2cf.png";